/* eslint-disable no-undef */
import getQuery from '../../utilities/query';
import { user } from '../../api';
import { handleError } from '../../utilities/errorHandling';

const queryClient = getQuery();

/* eslint-disable import/prefer-default-export */
export const KYC_REQUEST_SESSION = 'kyc.request_session';
queryClient.setMutationDefaults(KYC_REQUEST_SESSION, {
  mutationFn: user.requestSessionUrl,
  onError: (error) => {
    handleError(error);
  },
});
